/* eslint-disable no-empty-pattern */
import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Button } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { DefaultState } from '../../../../types'
import { getFileSize } from '../../../../utils/helpers'
import { LoadIndicator } from 'devextreme-react'
import './ScriptsDialog.css'
import useAsyncService from '../../../../hooks/useAsyncService'
import { downloadFile, getDownloadScript } from '../../../../services/endpoints/downloader'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'
import RenderDataModal from '../RenderViewModal/RenderViewModal'

export interface ScriptDialogProps {
  onClose: () => void
  script: {id: number, name: string}
}
const ScriptDialog: React.FC<ScriptDialogProps> = ({ onClose, script }) => {
  const {serviceLoading: scriptLoading, serviceError: scriptError, serviceValue: scriptData} = useAsyncService({
    serviceCall: getDownloadScript,
    initialArgs: script.id
  })

  const {serviceLoading: downloadLoading, serviceError: downloadError, setServiceArgs: setDownloadArgs} = useAsyncService({
    serviceCall: downloadFile,
    delay: 0,
    initialArgs: null
  })
  
  const handleDownload = (type: string) => {
    switch(type) {
      case 'vsdb':
        setDownloadArgs({type: 'vsdb', id: scriptData!.downloadFile.id, scriptId: script.id})
        break;
      
      case 'download':
        setDownloadArgs({type: 'download', id: scriptData!.downloadFile.id})
        break;

      default:
        console.error(`Error handling download for unknown type ${type}`)
    }
  }

  const getBody = () => {
    if(scriptLoading || downloadLoading) {
      return (
           <LoadIndicator />
      )
    } else if(scriptError) {
      return(
          <ICSErrorCard
            code={'error'}
            message={scriptError}
            fields={[]}
          />
      )
    } else if(!scriptData) {
      return <>Empty</>
    } else {
      return (
        <Container className="scripts-container">
          <Row className="scripts-row">
            <Col xs="2" className="scripts-col-2">
              <span className="script-bold">Script</span>
            </Col>
            <Col
              xs="5"
              className="scripts-col-5"
              style={{ maxWidth: 'max-content', width: 'max-content' }}
            >
              {script.name}{' '}
              <span style={{ fontStyle: 'italic' }}>
                {getFileSize(Number(scriptData?.downloadFile.size))}
              </span>
            </Col>
            <Col xs="1" className="scripts-col-1">
              <Button
                onClick={() => handleDownload('download')}
                className="script-download-btn"
              >
                <span className="glyphicons glyphicons-download-alt"></span>
              </Button>
            </Col>
          </Row>
          <Row className="scripts-row">
            <Col xs="2" className="scripts-col-2">
              <span className="script-bold">Collections</span>
            </Col>
            <Col
              xs="6"
              className="scripts-col-6"
              style={{ maxWidth: 'max-content', width: 'max-content' }}
            >
              {scriptData?.collections.map((collection, index) => {
                return <div key={index}>{collection.name}</div>
              })}
            </Col>
          </Row>
          <Row className="scripts-row">
            <Col xs="2" className="scripts-col-2">
              <span className="script-bold">VSDB</span>
            </Col>
            {scriptData?.vsdbName && (
              <Col
                xs="5"
                className="scripts-col-5"
                style={{ maxWidth: 'max-content', width: 'max-content' }}
              >
                {scriptData?.vsdbName}
              </Col>
            )}
            <Col xs="1" className="scripts-col-1">
              <Button
                onClick={() => handleDownload('vsdb')}
                className="script-download-btn"
              >
                <span className="glyphicons glyphicons-download-alt"></span>
              </Button>
            </Col>
          </Row>
          <Row className="scripts-row">
            <Col xs="2" className="scripts-col-2">
              <span className="script-bold">Uploaded</span>
            </Col>
            <Col
              xs="6"
              className="scripts-col-6"
              style={{ maxWidth: 'max-content', width: 'max-content' }}
            >
              {scriptData?.dateCreated}
            </Col>
          </Row>
          {(downloadError || downloadLoading) &&
            <Row className="scripts-row">
            <Col xs="2" className="scripts-col-2">
              <span className="script-bold">Downloading status</span>
            </Col>
            <Col
              xs="6"
              className="scripts-col-6"
              style={{ maxWidth: 'max-content', width: 'max-content' }}
            >
              {downloadError && <ICSErrorCard
                code={'error'}
                message={downloadError}
                fields={[]}
              />}

              {downloadLoading && <LoadIndicator />}
            </Col>
          </Row>
          }
        </Container>
      )
    }
  }

  return (
    <RenderDataModal onClose={onClose} title={'Extraction Notes for ' + script.name}>
      <Container className="notes-container">
        <Row className="notes-row">
          <Col>
            {getBody()}
          </Col>
        </Row>
      </Container>
    </RenderDataModal>
  )
}
export default ScriptDialog
